import React from "react";
import { FlatList, Image, View, TouchableOpacity, Dimensions, Pressable } from "react-native";
import { useTheme } from "@emotion/react";
import { useNavigation } from "@react-navigation/native";
import { ODSText } from "../../../openbrix-design-system/ui/atoms/ODSText";
import getScreenType from "../../../openbrix-design-system/utils/getScreenType";
import Wrapper from "./Wrapper";
import YoutubePlayer from '../../commonComponents/youtubePlayer/youtubePlayer';
import { navigateAction } from "../../helpers/navigationHelpers";
const HeaderWeb = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-web.png');
const HeaderTab = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-tab.png');
const HeaderMobile = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-mobile.png');
const Picture = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/tlyfe-logo.png');
const FooterWeb = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-web.png');
const FooterTab = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-tab.png');
const FooterMobile = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-mobile.png');
const clouds = require('../../../openbrix-design-system/images/tlyfe-pages/hangingCloud.png');
const mockVideo = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-video-mock-mobile.png');
const profile = require('../../../openbrix-design-system/images/icons/profile.png');
const sheild = require('../../../openbrix-design-system/images/icons/sheild.png');
const pound = require('../../../openbrix-design-system/images/icons/pound.png');
const face = require('../../../openbrix-design-system/images/icons/face.png');

const bank = require('../../../openbrix-design-system/images/icons/bank.png');
const chat = require('../../../openbrix-design-system/images/icons/chat.png');
const ins = require('../../../openbrix-design-system/images/icons/ins.png');
const market = require('../../../openbrix-design-system/images/icons/market.png');

const multiplecheck = require('../../../openbrix-design-system/images/icons/multiplecheck.png');

// Additional icons for benefits:
const rentReadySvg = require('../../assets/SVG/newIcons/rent_ready.svg');
const affordabilitySvg = require('../../assets/SVG/newIcons/affordability.svg');
const idVerificationSvg = require('../../assets/SVG/newIcons/id_verification.svg');
const digitalReferencesSvg = require('../../assets/SVG/newIcons/digital_references.svg');
const profileShareSvg = require('../../assets/SVG/newIcons/profile_share.svg');
const rightToRentSvg = require('../../assets/SVG/newIcons/right_to_rent.svg');
const moveInSvg = require('../../assets/SVG/newIcons/move_in.svg');
const homeSetupSvg = require('../../assets/SVG/newIcons/home_setup.svg');
const creditBuilderSvg = require('../../assets/SVG/newIcons/credit_builder.svg');
const tdsSvg = require('../../assets/SVG/OpenFlo/tdsIcon.svg');
const incomeProtectionSvg = require('../../assets/SVG/newIcons/income_protection.svg');
const rewardsSvg = require('../../assets/SVG/newIcons/rewards.svg');
const housingGatewaySvg = require('../../assets/SVG/newIcons/housing_gateway.svg');
const marketplaceSvg = require('../../assets/SVG/newIcons/marketplace.svg');
const propertySearchSvg = require('../../assets/SVG/newIcons/property_search.svg');

const rentReadyBig = require('../../assets/SVG/newIcons/rentReady.svg');
const tenancyProgressionBig = require('../../assets/SVG/newIcons/TenancyProgression.svg');
const tlyfeRewardsBig = require('../../assets/SVG/newIcons/tlyferewards.svg');
const creditBuilderBig = require('../../assets/SVG/newIcons/CreditBuilder.svg');
const tdsBig = require('../../assets/SVG/newIcons/tds.svg');
const marketplaceBig = require('../../assets/SVG/newIcons/marketplace2.svg');
const lastImage = require('../../assets/SVG/newIcons/lastImage.png');

const FEATURED = [

  {
    name: "Marketplace",
    desc: "Explore services tailored for tenants.",
    icon: market,
  },
  {
    name: "Credit Builder",
    desc: "Enhance your credit score as you rent.",
    icon: bank,
  },
  {
    name: "Tenant Insurance",
    desc: "Comprehensive coverage at your fingertips.",
    icon: ins,
  },
  {
    name: "Information Centre",
    desc: "Access essential resources and support.",
    icon: chat
  },
];

const COLUMN_1 = [
  {
    icon: rentReadySvg,
    title: "Rent Ready Solution",
    description: "The industry’s first, streamlining your rental process from start to finish.",
  },
  {
    icon: affordabilitySvg,
    title: "Affordability Calculator",
    description: "Know exactly what you can afford with our intuitive tool.",
  },
  {
    icon: idVerificationSvg,
    title: "ID Verification",
    description: "Secure and straightforward verification.",
  },
  {
    icon: digitalReferencesSvg,
    title: "Verified Digital References",
    description: "Present your credentials with confidence.",
  },
  {
    icon: profileShareSvg,
    title: "Document and Profile Share Centre",
    description: "View and share your documents with agents and landlords in a secure way.",
  },
];

const COLUMN_2 = [
  {
    icon: rightToRentSvg,
    title: "Right to Rent Checks",
    description: "Ensure compliance with ease.",
  },
  {
    icon: moveInSvg,
    title: "Move-in process",
    description: "Your agent using tlyfePRO will carry out the whole process within the tlyfe app.",
  },
  {
    icon: homeSetupSvg,
    title: "Home Set-Up",
    description: "Get your bills all set up for your move-in, to include, Council Tax, Water, Gas, Electric, Broadband, TV packages etc.",
  },
  {
    icon: creditBuilderSvg,
    title: "Build your Credit",
    description: "Report your rental payments to help boost your credit score.",
  },
  {
    icon: tdsSvg,
    title: "View and Manage your Protected Deposit",
    description: "With smart integration with the Tenancy Deposit Scheme (TDS)",
  },
];

const COLUMN_3 = [
  {
    icon: incomeProtectionSvg,
    title: "Income Protection",
    description: "If you fall ill or suffer from an injury, protect your rent",
  },
  {
    icon: rewardsSvg,
    title: "Rewards",
    description: "Take advantage of tlyfe rewards",
  },
  {
    icon: housingGatewaySvg,
    title: "My Housing Issue Gateway",
    description: "Free to use should you need help resolving a tenancy related issue.",
  },
  {
    icon: marketplaceSvg,
    title: "Marketplace",
    description: "For things tenancy related.",
  },
  {
    icon: propertySearchSvg,
    title: "Property Rental Search",
    description: "A growing number of agents and landlords are listing their properties with tlyfe. Share your profile directly with the agent or landlord to jump the queue and secure your next tenancy.",
  },
];

const BenefitItem = ({ icon, title, description }) => (
  <View style={{ marginTop: 20, flexDirection: "row", alignItems: "flex-start" }}>
    <Image style={{ height: 30, width: 30, marginRight: 12, marginTop: 2 }} resizeMode="contain" source={icon} />
    <View style={{ flexDirection: "column", flex: 1 }}>
      <ODSText type="button">{title}</ODSText>
      <ODSText type="sm" style={{ marginTop: 6 }}>{description}</ODSText>
    </View>
  </View>
);

const BeyondRentingCard = ({
  title,
  description,
  image,
  bgColor,
  textColor = "black",
  imagePosition = "right",
  buttonText,
  onButtonPress,
  flexValue = 1,
  imageStyle,
  cardStyle,
  textFlex = 1,
  imageFlex = 1,
  imageResizeMode = "contain",
}) => {
  const layout = getScreenType();
  const isMobile = layout === "phone";
  const isTitleOnly = title === "And much more!" || (!description && !buttonText && !image);

  // Determine flexDirection based on position and mobile state
  let flexDirection: 'row' | 'row-reverse' | 'column' | 'column-reverse' = 'row';
  if (isMobile) {
    if (imagePosition === "top" || imagePosition === "left") {
      flexDirection = "column";
    } else {
      flexDirection = "column-reverse"; // Text on top, image below on mobile
    }
  } else {
    if (imagePosition === "left") flexDirection = "row-reverse"; // text right, image left
    else if (imagePosition === "right") flexDirection = "row"; // text left, image right
    else if (imagePosition === "top") flexDirection = "column-reverse"; // text below, image top
    else if (imagePosition === "bottom") flexDirection = "column"; // text top, image bottom
    else flexDirection = "column"; // default/none
  }

  // Calculate text padding based on position to allow images to touch borders
  let textPadding = {};
  if (imagePosition === "none") {
    textPadding = { padding: 24 };
  } else if (isMobile) {
    if (imagePosition === "top" || imagePosition === "left") {
      textPadding = { paddingHorizontal: 24, paddingBottom: 24, paddingTop: 16 };
    } else {
      textPadding = { paddingHorizontal: 24, paddingTop: 24, paddingBottom: 16 };
    }
  } else {
    if (imagePosition === "left") {
      textPadding = { paddingVertical: 24, paddingRight: 24, paddingLeft: 16 };
    } else if (imagePosition === "right") {
      textPadding = { paddingVertical: 24, paddingLeft: 24, paddingRight: 16 };
    } else if (imagePosition === "top") {
      textPadding = { paddingHorizontal: 24, paddingBottom: 24, paddingTop: 16 };
    } else if (imagePosition === "bottom") {
      textPadding = { paddingHorizontal: 24, paddingTop: 24, paddingBottom: 16 };
    }
  }

  const containerStyle = {
    flex: isMobile ? undefined : flexValue,
    backgroundColor: bgColor,
    borderRadius: 16,
    padding: 0, // Zero padding on container to let image touch borders
    margin: isMobile ? 8 : 12,
    flexDirection: isTitleOnly ? "column" : flexDirection,
    alignItems: "center",
    justifyContent: isTitleOnly ? "center" : "space-between",
    overflow: "hidden" as const,
    ...cardStyle,
  };

  const textContent = (
    <View style={{
      flex: isTitleOnly ? 0 : textFlex,
      minWidth: isMobile ? "100%" : undefined,
      alignItems: isTitleOnly ? "center" : "flex-start",
      justifyContent: isTitleOnly ? "center" : "flex-start",
      ...textPadding
    }}>
      {title && (
        <ODSText
          type="h3"
          color={textColor}
          textAlign={isTitleOnly ? "center" : "left"}
          style={isTitleOnly ? undefined : { marginBottom: 12 }}
        >
          {title}
        </ODSText>
      )}
      {description && (
        <ODSText type="sm" marginTop={10} color={textColor} >
          {description}
        </ODSText>
      )}
      {buttonText && (
        <TouchableOpacity
          onPress={onButtonPress}
          style={{
            backgroundColor: "#22A8B5",
            borderRadius: 20,
            paddingVertical: 10,
            paddingHorizontal: 20,
            alignSelf: "flex-start",
            marginTop: 16,
          }}
        >
          <ODSText type="button" color="white">
            {buttonText}
          </ODSText>
        </TouchableOpacity>
      )}
    </View>
  );

  const imageContent = image && (
    <View style={{ flex: imageFlex, alignItems: "center", justifyContent: "center", width: "100%", padding: 0 }}>
      <Image
        source={image}
        style={{
          width: "100%",
          height: 180,
          ...imageStyle,
        }}
        resizeMode={imageResizeMode}
      />
    </View>
  );

  return (
    <View style={containerStyle}>
      {textContent}
      {imageContent}
    </View>
  );
};

const BEYOND_RENTING_DATA = [
  {
    title: "Rent Ready",
    description: "Give yourself the best chance of securing your next rental property by using our Pre-qualification tool to become a ‘Rent Ready’ Tenant. Share the results with your Agent to put yourself ahead of the crowd!!",
    image: rentReadyBig,
    bgColor: "#FEF4CC",
    textColor: "black",
    imagePosition: "top",
    imageStyle: { height: 180 },
  },
  {
    title: "Info hub",
    description: "Your go-to source for tenant news, insights, and helpful guides. Discover expert advice, industry updates, and practical resources to help you rent smarter and stay informed every step of the way.",
    bgColor: "#E6F5F8",
    textColor: "black",
    imagePosition: "none",
    buttonText: "Go to Info Hub",
  },
  {
    title: "Tenancy Progression",
    description: "Track and manage your tenancy journey with ease. Stay informed with key updates, important milestones, and helpful resources from application through to move-in and beyond.",
    image: tenancyProgressionBig,
    bgColor: "#9F76C4",
    textColor: "white",
    imagePosition: "bottom",
    imageStyle: { height: 180 },
  },
  {
    title: "tlyfe rewards",
    description: "Access everyday savings from hundreds of High Street retailers with our rewards programme, unlocking exclusive offers and discounts.",
    image: tlyfeRewardsBig,
    bgColor: "#FAC0C7",
    textColor: "black",
    imagePosition: "top",
    imageStyle: { height: 180 },
  },
  {
    title: "Marketplace",
    description: "Explore services tailored for tenants.",
    image: marketplaceBig,
    bgColor: "#E6F5F8",
    textColor: "black",
    imagePosition: "top",
    imageStyle: { height: 120 },
    imageResizeMode: "cover",
  },
  {
    title: "Deposit Protection",
    description: "Keep your tenancy secure with deposit protection information and guidance. Learn how your deposit is safeguarded, understand your rights and responsibilities, and access helpful resources throughout your rental journey.",
    image: tdsBig,
    bgColor: "#22A8B5",
    textColor: "white",
    imagePosition: "bottom",
    imageStyle: { height: 180 },
  },
  {
    title: "Credit Builder",
    description: "Record your rental payments with tlyfe and have these reported to all major credit reference agencies, helping to improve your credit score and get you mortgage-ready! Supported by all major UK banks",
    image: creditBuilderBig,
    bgColor: "#9F76C4",
    textColor: "white",
    imagePosition: "bottom",
    imageStyle: { height: 180 },
  },
  {
    title: "And much more!",
    bgColor: "#FEEBA7",
    textColor: "black",
    imagePosition: "none",
    cardStyle: { justifyContent: "center", alignItems: "center" },
  }
];

const BeyondRentingSlider = () => {
  const { colors } = useTheme();
  const layout = getScreenType();
  const navigation = useNavigation();
  const isPhone = layout === "phone";
  const windowWidth = Dimensions.get('window').width;

  const carouselWidth = isPhone ? Math.min(windowWidth * 0.88, 430) : Math.min(windowWidth * 0.9, 800);
  const itemWidth = isPhone ? carouselWidth : 340;
  const cardWidth = isPhone ? carouselWidth - 30 : 320;

  const [activeIndex, setActiveIndex] = React.useState(0);
  const listRef = React.useRef(null);

  const moveSlider = (direction) => {
    const nextIndex = direction === "next"
      ? (activeIndex + 1) % BEYOND_RENTING_DATA.length
      : (activeIndex - 1 + BEYOND_RENTING_DATA.length) % BEYOND_RENTING_DATA.length;

    listRef.current?.scrollToOffset({
      offset: nextIndex * itemWidth,
      animated: true,
    });
    setActiveIndex(nextIndex);
  };

  return (
    <View style={{ flexDirection: "column", width: "100%", alignItems: "center" }}>
      <View style={{
        width: isPhone ? carouselWidth : carouselWidth + 60,
        alignSelf: "center",
        position: "relative",
      }}>
        <FlatList
          ref={listRef}
          data={BEYOND_RENTING_DATA}
          horizontal
          showsHorizontalScrollIndicator={false}
          snapToInterval={itemWidth}
          snapToAlignment="center"
          decelerationRate="fast"
          disableIntervalMomentum
          onMomentumScrollEnd={(event) => {
            setActiveIndex(Math.round(
              event.nativeEvent.contentOffset.x / itemWidth
            ));
          }}
          contentContainerStyle={{
            paddingHorizontal: isPhone ? 15 : 30,
          }}
          style={{
            width: "100%",
            alignSelf: "center",
          }}
          keyExtractor={(_, index) => index.toString()}
          renderItem={({ item }) => (
            <View style={{ width: cardWidth, marginHorizontal: 5 }}>
              <BeyondRentingCard
                title={item.title}
                description={item.description}
                image={item.image}
                bgColor={item.bgColor}
                textColor={item.textColor}
                imagePosition={item.imagePosition}
                buttonText={item.buttonText}
                onButtonPress={item.title === "Info hub" ? () => navigateAction(navigation, 'MediaHub') : undefined}
                imageStyle={{ ...item.imageStyle, height: 160 }}
                cardStyle={{ height: 440, justifyContent: "space-between", ...item.cardStyle }}
                imageResizeMode={item.imageResizeMode as any}
              />
            </View>
          )}
        />

        {/* Navigation Arrows */}
        <Pressable
          onPress={() => moveSlider("previous")}
          style={{
            position: "absolute",
            left: isPhone ? 0 : -35,
            top: 200,
            width: 44,
            height: 54,
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <ODSText color={colors.main.blue["500"]} fontSize={52} type="sm">‹</ODSText>
        </Pressable>
        <Pressable
          onPress={() => moveSlider("next")}
          style={{
            position: "absolute",
            right: isPhone ? 0 : -35,
            top: 200,
            width: 44,
            height: 54,
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <ODSText color={colors.main.blue["500"]} fontSize={52} type="sm">›</ODSText>
        </Pressable>
      </View>

      {/* Pagination Dots */}
      <View style={{
        flexDirection: "row",
        justifyContent: "center",
        marginTop: 24,
      }}>
        {BEYOND_RENTING_DATA.map((_, index) => (
          <Pressable
            key={`dot-${index}`}
            onPress={() => {
              listRef.current?.scrollToOffset({
                offset: index * itemWidth,
                animated: true,
              });
              setActiveIndex(index);
            }}
            style={{
              width: 12,
              height: 12,
              borderRadius: 6,
              marginHorizontal: 6,
              backgroundColor: index === activeIndex
                ? colors.main.blue["500"]
                : "rgba(19, 179, 193, 0.3)",
            }}
          />
        ))}
      </View>
    </View>
  );
};

const TlyfeproLanding = () => {
  const { colors } = useTheme();
  const layout = getScreenType();
  const navigation = useNavigation();

  const headerImage = layout === "web" ? HeaderWeb : layout === "tab" ? HeaderTab : HeaderMobile;
  const footerImage = layout === "web" ? FooterWeb : layout === "tab" ? FooterTab : FooterMobile;

  const sectionStyles = layout === "phone"
    ? { flexDirection: "column", alignItems: "center", paddingHorizontal: "6%", marginBottom: 30 }
    : { flexDirection: "row", justifyContent: "center", paddingVertical: 100 };

  return (
    <Wrapper
      theme={colors.transparency.pink}
      drawerColor={colors.theme.pink}
      isOpenBrixLogo
      bodyStyle={{ alignSelf: "flex-start" }}
      type="login"
      imageStyle={layout == "phone" ? { height: 900, justifyContent: "flex-start", paddingTop: 100 } : { height: 500, justifyContent: "center", paddingTop: 20 }}
      headerTitle="Rent Smarter With The Tenant Lifecycle App, currently used by over 350,000 UK tenants!"
      headerBody="tlyfe has redefined the rental experience, making life as a tenant simpler and more efficient. As the UK’s number one tenant app, tlyfe empowers you to secure your preferred property with ease and manage your tenancy effortlessly."
      headerImage={headerImage}
      headerBlacFont
      rightImage={Picture}
      leftText={`Give yourself the best chance of securing your next rental property by using our Pre-qualification tool to become a ‘Rent Ready’ Tenant.\n\nShare the results with your Agent to put yourself ahead of the crowd!!`}
      footerImage={footerImage}
      tlyfeProMenu
    >
      <View style={{ position: "relative" }}>
        <Image source={require("../../../openbrix-design-system/images/tlyfe-pages/clouds.png")}
          style={{ width: "100%", height: 100, position: "absolute", top: -97 }} />
        <View style={{
          flexDirection: "column",
          paddingHorizontal: layout === "phone" ? "6%" : "10%",
          paddingTop: layout === "phone" ? 40 : 80,
          paddingBottom: layout === "phone" ? 60 : 100,
          backgroundColor: "white",
        }}>
          <ODSText
            type="h3"
            color={colors.main.blue["500"]}
            textAlign="center"
            style={{ marginBottom: 20 }}
          >
            Key Benefits
          </ODSText>

          <View style={{
            flexDirection: layout === "phone" ? "column" : "row",
            justifyContent: "space-between",
            width: "100%",
          }}>
            <View style={{ flex: 1, marginRight: layout === "phone" ? 0 : 30, marginBottom: layout === "phone" ? 20 : 0 }}>
              {COLUMN_1.map((item, idx) => (
                <BenefitItem key={idx} icon={item.icon} title={item.title} description={item.description} />
              ))}
            </View>

            <View style={{ flex: 1, marginRight: layout === "phone" ? 0 : 30, marginBottom: layout === "phone" ? 20 : 0 }}>
              {COLUMN_2.map((item, idx) => (
                <BenefitItem key={idx} icon={item.icon} title={item.title} description={item.description} />
              ))}
            </View>

            <View style={{ flex: 1 }}>
              {COLUMN_3.map((item, idx) => (
                <BenefitItem key={idx} icon={item.icon} title={item.title} description={item.description} />
              ))}
            </View>
          </View>
        </View>
        <View style={layout === "phone" ?
          { ...sectionStyles, paddingTop: 20, backgroundColor: colors.main.purple["500"], justifyContent: "center", alignItems: "center", flexDirection: "column-reverse" } :
          { ...sectionStyles, backgroundColor: colors.main.purple["500"], height: 422, justifyContent: "center", alignItems: "center" }}>
          {layout == "phone" ? null : <>
            <Image
              style={layout === "phone" ? { height: 100, width: 73, position: "absolute", top: 0, right: 20 } : { height: 100, width: 73, position: "absolute", top: 0, right: 20 }}
              source={clouds}
            />
            <Image
              style={layout === "phone" ? { height: 52, width: 41, position: "absolute", top: 0, left: 40 } : { height: 131, width: 108, position: "absolute", top: 0, left: 40 }}
              source={clouds}
            />
          </>}

          <View style={{ marginLeft: layout === "phone" ? "0%" : "2%", position: "relative" }}>
            <Image
              style={layout === "phone" ? { height: 241, width: 200, bottom: -30 } : { height: 435, width: 250, marginRight: "2%", bottom: -73 }}
              resizeMode="contain"
              source={mockVideo}
            />
          </View>
          <View style={layout === "phone" ? {} : { marginLeft: "2%", width: "31%" }}>
            <ODSText color="white" type="h3">Seamless Integration</ODSText>
            <ODSText color="white" marginTop={10} type="sm">
              By allowing tenants to pre-qualify themselves, tlyfe guarantees a smoother, faster, and more transparent rental journey. This innovative approach reduces the time and effort required to find a property, enhancing confidence for both tenants and agents.
            </ODSText>
          </View>
        </View>
        <View style={{
          paddingHorizontal: layout === "phone" ? "6%" : "10%",
          paddingVertical: layout === "phone" ? 40 : 80,
          backgroundColor: "#FDFDFD",
        }}>
          <ODSText type="h3" color={"black"} textAlign="center" style={{ marginBottom: 40 }}>
            Beyond Renting
          </ODSText>

          {layout === "phone" || layout === "tab" ? (
            <BeyondRentingSlider />
          ) : (
            <>
              <View style={{ flexDirection: "row", width: "100%" }}>
                <BeyondRentingCard
                  title="Rent Ready"
                  description="Give yourself the best chance of securing your next rental property by using our Pre-qualification tool to become a ‘Rent Ready’ Tenant. Share the results with your Agent to put yourself ahead of the crowd!!"
                  image={rentReadyBig}
                  bgColor="#FEF4CC"
                  imagePosition="left"
                  textFlex={1.2}
                  imageFlex={0.8}
                  imageStyle={{ height: 220 }}
                />
              </View>

              <View style={{ flexDirection: "row", width: "100%" }}>
                <BeyondRentingCard
                  title="Info hub"
                  description="Your go-to source for tenant news, insights, and helpful guides. Discover expert advice, industry updates, and practical resources to help you rent smarter and stay informed every step of the way."
                  bgColor="#E6F5F8"
                  imagePosition="none"
                  buttonText="Go to Info Hub"
                  onButtonPress={() => navigateAction(navigation, 'MediaHub')}
                  flexValue={1}
                />
                <BeyondRentingCard
                  title="Tenancy Progression"
                  description="Track and manage your tenancy journey with ease. Stay informed with key updates, important milestones, and helpful resources from application through to move-in and beyond."
                  image={tenancyProgressionBig}
                  bgColor="#9F76C4"
                  textColor="white"
                  imagePosition="left"
                  flexValue={1.8}
                  textFlex={1.2}
                  imageFlex={0.8}
                  imageStyle={{ height: 200 }}
                />
              </View>

              <View style={{ flexDirection: "row", width: "100%" }}>
                <BeyondRentingCard
                  title="tlyfe rewards"
                  description="Access everyday savings from hundreds of High Street retailers with our rewards programme, unlocking exclusive offers and discounts."
                  image={tlyfeRewardsBig}
                  bgColor="#FAC0C7"
                  imagePosition="right"
                  flexValue={1.8}
                  textFlex={1.2}
                  imageFlex={0.8}
                  imageStyle={{ height: 200 }}
                />
                <BeyondRentingCard
                  title="Marketplace"
                  description="Explore services tailored for tenants."
                  image={marketplaceBig}
                  bgColor="#E6F5F8"
                  imagePosition="top"
                  flexValue={1}
                  textFlex={1}
                  imageFlex={1}
                  imageStyle={{ height: 120 }}
                  imageResizeMode="cover"
                />
              </View>

              <View style={{ flexDirection: "row", width: "100%" }}>
                <BeyondRentingCard
                  title="Deposit Protection"
                  description="Keep your tenancy secure with deposit protection information and guidance. Learn how your deposit is safeguarded, understand your rights and responsibilities, and access helpful resources throughout your rental journey."
                  image={tdsBig}
                  bgColor="#22A8B5"
                  textColor="white"
                  imagePosition="right"
                  textFlex={1.2}
                  imageFlex={0.8}
                  imageStyle={{ height: 180 }}
                />
              </View>

              <View style={{ flexDirection: "row", width: "100%" }}>
                <BeyondRentingCard
                  title="Credit Builder"
                  description="Record your rental payments with tlyfe and have these reported to all major credit reference agencies, helping to improve your credit score and get you mortgage-ready! Supported by all major UK banks"
                  image={creditBuilderBig}
                  bgColor="#9F76C4"
                  textColor="white"
                  imagePosition="right"
                  flexValue={1.8}
                  textFlex={1.2}
                  imageFlex={0.8}
                  imageStyle={{ height: 220 }}
                />
                <BeyondRentingCard
                  title="And much more!"
                  bgColor="#FEEBA7"
                  imagePosition="none"
                  flexValue={1}
                  cardStyle={{ justifyContent: "center", alignItems: "center", minHeight: 200 }}
                />
              </View>
            </>
          )}
        </View>
        <View style={layout === "phone" ?
          { ...sectionStyles, paddingTop: 20, backgroundColor: colors.main.salmon["200"], justifyContent: "center", alignItems: "center", flexDirection: "column-reverse", marginBottom: 0, padding: 60 } :
          { ...sectionStyles, backgroundColor: colors.main.salmon["200"], justifyContent: "center", alignItems: "center", flexDirection: "row-reverse" }}>
          <Image source={require("../../../openbrix-design-system/images/tlyfe-pages/clouds.png")}
            style={{
              width: "100%", height: 100, position: "absolute",
              top: -3,
              transform: [{ rotate: '180deg' }]
            }} />
          <View style={{ marginLeft: layout === "phone" ? "0%" : "2%", position: "relative" }}>
            <View
              style={layout === "phone" ? { height: 400, width: 200, overflow: 'hidden' } : {
                height: 622, width: 300, marginRight: "2%",
              }}
            >
              {/* <YoutubePlayer
                url={'https://youtube.com/shorts/Ce49JrtkBmw?feature=share'}
                width="100%"
                height="100%"
                style={{ borderTopRightRadius: 8, borderTopLeftRadius: 8, overflow: 'hidden' }}
              /> */}
              <Image
                source={lastImage}
                style={{ width: "100%", height: "100%" }}
                resizeMode="contain"
              />
            </View>
          </View>
          <View style={layout === "phone" ? { marginBottom: 20 } : { marginLeft: "2%", width: "30%" }}>
            <ODSText color="black" textAlign={"flex-start"} type="h3">Experience the future of renting with tlyfe.</ODSText>
            <ODSText color="black" textAlign={"flex-start"} marginTop={10} type="sm">
              Simplify your rental journey and enjoy peace of mind, all in one app.
            </ODSText>
          </View>
        </View>
      </View>
    </Wrapper>
  );
};

export default TlyfeproLanding;
